import { AssetClassLandAreaComponentModel } from "../../asset_class";
import { LandArea } from "./types";

export function mapAssetClassLandAreaComponentToLandArea(item: AssetClassLandAreaComponentModel): LandArea {
  return {
    surface: item.surface,
    undergroundRestriction: item.underground_restriction,
    aerialRestriction: item.aerial_restriction,
    limitedUse: item.limited_use,
    unitAreaMeasurementId: item.unit_area_measurement_id,
    unitLengthMeasurementId: item.unit_length_measurement_id
  }
}

export function mapLandAreaToAssetClassLandAreaComponent(item: LandArea): AssetClassLandAreaComponentModel {
  const model = new AssetClassLandAreaComponentModel()
  model.clear()
  model.surface = item.surface
  model.limited_use = item.limitedUse
  model.underground_restriction = item.undergroundRestriction ?? 0;
  model.aerial_restriction = item.aerialRestriction ?? 0
  model.unit_area_measurement_id = item.unitAreaMeasurementId
  model.unit_length_measurement_id = item.unitLengthMeasurementId
  return model
}